<p-dropdown (onChange)="statusChange($event.value)" [options]="statuses" [(ngModel)]="status"
            placeholder="Select a Status" optionLabel="title">

    <ng-template let-options pTemplate="options">
        <span class="ng-star-inserted">{{options.title}}</span>
        <span class="status-indicator"
             style.background-color="#{{options.color}}">
        </span>
    </ng-template>
</p-dropdown>